import {
  Lightning, Drop, ThermometerCold, Bathtub, Wrench, WashingMachine,
  WifiHigh, Elevator, Snowflake, Lightbulb, CurrencyEur, Bed, Users,
  ClipboardText, TreePalm, DeviceMobile, Cube, X, Buildings,
  Compass, Info, Key, Car, Question
} from "@phosphor-icons/react";
import { TicketLabel } from "shared/types/helpdesk";

export interface LabelConfig {
  icon: React.ReactNode;
  bgColor: string;
  textColor: string;
}

export const getHelpdeskLabelIconAndColor = (label: TicketLabel): LabelConfig => {
  const labelConfig: Record<TicketLabel, LabelConfig> = {
    [TicketLabel.Elektriciteit]: {
      icon: <Lightning className="h-4 w-4" />,
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-800'
    },
    [TicketLabel.VochtWater]: {
      icon: <Drop className="h-4 w-4" />,
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-800'
    },
    [TicketLabel.Verwarming]: {
      icon: <ThermometerCold className="h-4 w-4" />,
      bgColor: 'bg-orange-100',
      textColor: 'text-orange-800'
    },
    [TicketLabel.Sanitair]: {
      icon: <Bathtub className="h-4 w-4" />,
      bgColor: 'bg-cyan-100',
      textColor: 'text-cyan-800'
    },
    [TicketLabel.Onderhoud]: {
      icon: <Wrench className="h-4 w-4" />,
      bgColor: 'bg-green-100',
      textColor: 'text-green-800'
    },
    [TicketLabel.Poetsen]: {
      icon: <WashingMachine className="h-4 w-4" />,
      bgColor: 'bg-pink-100',
      textColor: 'text-pink-800'
    },
    [TicketLabel.Internet]: {
      icon: <WifiHigh className="h-4 w-4" />,
      bgColor: 'bg-blue-200',
      textColor: 'text-blue-900'
    },
    [TicketLabel.Lift]: {
      icon: <Elevator className="h-4 w-4" />,
      bgColor: 'bg-indigo-200',
      textColor: 'text-indigo-900'
    },
    [TicketLabel.HVAC]: {
      icon: <Snowflake className="h-4 w-4" />,
      bgColor: 'bg-sky-100',
      textColor: 'text-sky-800'
    },
    [TicketLabel.Verlichting]: {
      icon: <Lightbulb className="h-4 w-4" />,
      bgColor: 'bg-yellow-300',
      textColor: 'text-yellow-900'
    },
    [TicketLabel.Facturatie]: {
      icon: <CurrencyEur className="h-4 w-4" />,
      bgColor: 'bg-emerald-100',
      textColor: 'text-emerald-800'
    },
    [TicketLabel.Nutsvoorzieningen]: {
      icon: <Lightning className="h-4 w-4" />,
      bgColor: 'bg-purple-100',
      textColor: 'text-purple-800'
    },
    [TicketLabel.Boekhouding]: {
      icon: <CurrencyEur className="h-4 w-4" />,
      bgColor: 'bg-teal-100',
      textColor: 'text-teal-800'
    },
    [TicketLabel.Inrichting]: {
      icon: <Bed className="h-4 w-4" />,
      bgColor: 'bg-fuchsia-100',
      textColor: 'text-fuchsia-800'
    },
    [TicketLabel.Huurdersdiscussies]: {
      icon: <Users className="h-4 w-4" />,
      bgColor: 'bg-rose-100',
      textColor: 'text-rose-800'
    },
    [TicketLabel.VragenHuurcontract]: {
      icon: <ClipboardText className="h-4 w-4" />,
      bgColor: 'bg-fuchsia-200',
      textColor: 'text-fuchsia-900'
    },
    [TicketLabel.Tuinonderhoud]: {
      icon: <TreePalm className="h-4 w-4" />,
      bgColor: 'bg-green-200',
      textColor: 'text-green-900'
    },
    [TicketLabel.ElectronischeToestellen]: {
      icon: <DeviceMobile className="h-4 w-4" />,
      bgColor: 'bg-violet-100',
      textColor: 'text-violet-800'
    },
    [TicketLabel.Meubilair]: {
      icon: <Cube className="h-4 w-4" />,
      bgColor: 'bg-amber-200',
      textColor: 'text-amber-900'
    },
    [TicketLabel.Afbraakwerken]: {
      icon: <Wrench className="h-4 w-4" />,
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-800'
    },
    [TicketLabel.Asbest]: {
      icon: <X className="h-4 w-4" />,
      bgColor: 'bg-red-200',
      textColor: 'text-red-900'
    },
    [TicketLabel.Balustrade]: {
      icon: <Buildings className="h-4 w-4" />,
      bgColor: 'bg-indigo-100',
      textColor: 'text-indigo-800'
    },
    [TicketLabel.Binnenschrijnwerk]: {
      icon: <Buildings className="h-4 w-4" />,
      bgColor: 'bg-amber-100',
      textColor: 'text-amber-800'
    },
    [TicketLabel.Brandbeveiliging]: {
      icon: <Lightning className="h-4 w-4" />,
      bgColor: 'bg-red-100',
      textColor: 'text-red-800'
    },
    [TicketLabel.Dak]: {
      icon: <Buildings className="h-4 w-4" />,
      bgColor: 'bg-slate-100',
      textColor: 'text-slate-800'
    },
    [TicketLabel.ElastischeVoegen]: {
      icon: <Buildings className="h-4 w-4" />,
      bgColor: 'bg-lime-100',
      textColor: 'text-lime-800'
    },
    [TicketLabel.Gevel]: {
      icon: <Buildings className="h-4 w-4" />,
      bgColor: 'bg-stone-100',
      textColor: 'text-stone-800'
    },
    [TicketLabel.Overige]: {
      icon: <Question className="h-4 w-4" />,
      bgColor: 'bg-gray-200',
      textColor: 'text-gray-900'
    },
    [TicketLabel.Riolering]: {
      icon: <Drop className="h-4 w-4" />,
      bgColor: 'bg-blue-300',
      textColor: 'text-blue-900'
    },
    [TicketLabel.Rolluik]: {
      icon: <Buildings className="h-4 w-4" />,
      bgColor: 'bg-amber-200',
      textColor: 'text-amber-900'
    },
    [TicketLabel.Ruwbouw]: {
      icon: <Buildings className="h-4 w-4" />,
      bgColor: 'bg-stone-200',
      textColor: 'text-stone-900'
    },
    [TicketLabel.Verstopping]: {
      icon: <Drop className="h-4 w-4" />,
      bgColor: 'bg-amber-100',
      textColor: 'text-amber-800'
    },
    [TicketLabel.Stabiliteit]: {
      icon: <Buildings className="h-4 w-4" />,
      bgColor: 'bg-red-300',
      textColor: 'text-red-900'
    },
    [TicketLabel.SuggestiesHuurdersVerbeteringen]: {
      icon: <Lightbulb className="h-4 w-4" />,
      bgColor: 'bg-emerald-200',
      textColor: 'text-emerald-900'
    },
    [TicketLabel.Trap]: {
      icon: <Buildings className="h-4 w-4" />,
      bgColor: 'bg-slate-200',
      textColor: 'text-slate-900'
    },
    [TicketLabel.Ventilatie]: {
      icon: <Compass className="h-4 w-4" />,
      bgColor: 'bg-sky-200',
      textColor: 'text-sky-900'
    },
    [TicketLabel.VergunningAttest]: {
      icon: <ClipboardText className="h-4 w-4" />,
      bgColor: 'bg-lime-200',
      textColor: 'text-lime-900'
    },
    [TicketLabel.VloerenParket]: {
      icon: <Cube className="h-4 w-4" />,
      bgColor: 'bg-amber-300',
      textColor: 'text-amber-900'
    },
    [TicketLabel.Signalisatie]: {
      icon: <Info className="h-4 w-4" />,
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-800'
    },
    [TicketLabel.Glasbreuk]: {
      icon: <X className="h-4 w-4" />,
      bgColor: 'bg-red-100',
      textColor: 'text-red-800'
    },
    [TicketLabel.Bezetting]: {
      icon: <Users className="h-4 w-4" />,
      bgColor: 'bg-purple-100',
      textColor: 'text-purple-800'
    },
    [TicketLabel.Toegangsbeheer]: {
      icon: <Key className="h-4 w-4" />,
      bgColor: 'bg-zinc-200',
      textColor: 'text-zinc-900'
    },
    [TicketLabel.Buitenschrijnwerk]: {
      icon: <Buildings className="h-4 w-4" />,
      bgColor: 'bg-teal-200',
      textColor: 'text-teal-900'
    },
    [TicketLabel.Garage]: {
      icon: <Car className="h-4 w-4" />,
      bgColor: 'bg-zinc-100',
      textColor: 'text-zinc-800'
    },
    [TicketLabel.Gebouwattributen]: {
      icon: <Car className="h-4 w-4" />,
      bgColor: 'bg-amber-200',
      textColor: 'text-amber-900'
    },
    [TicketLabel.AfvalEnOngedierte]: {
      icon: <X className="h-4 w-4" />,
      bgColor: 'bg-red-200',
      textColor: 'text-red-900'
    },
    [TicketLabel.Karweien]: {
      icon: <Wrench className="h-4 w-4" />,
      bgColor: 'bg-yellow-200',
      textColor: 'text-yellow-900'
    },
    [TicketLabel.UNKNOWN]: {
      icon: <Question className="h-4 w-4" />,
      bgColor: 'bg-neutral-secondary-mid/10',
      textColor: 'text-neutral-primary'
    },
  };

  return labelConfig[label] || labelConfig[TicketLabel.UNKNOWN];
};